import './header-group';
import './scroll-to';

// only load facets filters and side drawer on collection and search pages
// TODO: when lazy loading of web components feature is finished, we can remove these.
// ! if anything else utilizes the side drawer, we need to move this outside of this conditional.
if (window.location.pathname.includes('collections') || window.location.pathname.includes('search')) {
  import(/* webpackChunkName: "side-drawer" */'../web-components/side-drawer').then(module => {
    customElements.define('side-drawer', module.SideDrawer);
  });
  import(/* webpackChunkName: "facets-filters" */'../web-components/facets').then(module => {
    customElements.define('facets-filters', module.FacetsFilters);
  });
}
if (document.querySelector('collection-view-more')) {
  import(/* webpackChunkName: "collection-view-more" */'../web-components/collection-view-more').then(module => {
    customElements.define('collection-view-more', module.CollectionViewMore);
  });
}
if (document.querySelector('product-gating-info')) {
  import(/* webpackChunkName: "product-gating-info" */'../web-components/product-gating-info');
}
const particleAnimationContainer = document.getElementById('particle-animation-container');
if (particleAnimationContainer) {
  import(/* webpackChunkName: "particle-animation-chunk" */'./particle-animation').then(_ref => {
    let {
      ParticleAnimation
    } = _ref;
    return ParticleAnimation.init(particleAnimationContainer);
  });
}
if (!Shopify.designMode) {
  const productCards = document.querySelectorAll('.product_card');
  productCards.forEach(productCard => {
    const productCardLink = productCard.querySelector('a');
    const gtm_item_name = productCard.querySelector('[name="gtm_item_name"]').getAttribute('value');
    const gtm_item_id = productCard.querySelector('[name="gtm_item_id"]').getAttribute('value');
    const gtm_item_collection = productCard.querySelector('[name="gtm_item_collection"]')?.getAttribute('value') || '';
    const gtm_item_variant = productCard.querySelector('[name="gtm_item_variant"]').getAttribute('value');
    const gtm_item_upc = productCard.querySelector('[name="gtm_item_upc"]').getAttribute('value');
    const gtm_item_price = productCard.querySelector('[name="gtm_item_price"]').getAttribute('value');
    const gtm_item_sku = productCard.querySelector('[name="gtm_item_sku"]')?.getAttribute('value');
    const gtm_item_brand = productCard.querySelector('[name="gtm_item_brand"]')?.getAttribute('value') || '';
    const gtm_item_list_id = productCard.querySelector('[name="gtm_item_list_id"]')?.getAttribute('value') || '';
    const gtm_item_list_name = productCard.querySelector('[name="gtm_item_list_name"]')?.getAttribute('value') || '';
    const gtm_item_category = productCard.querySelector('[name="gtm_item_category"]')?.getAttribute('value') || '';
    productCardLink?.addEventListener('click', function (e) {
      const customEvent = {
        currency: window.currentCurrency,
        items: [{
          item_name: gtm_item_name,
          item_id: gtm_item_id,
          item_category: gtm_item_collection,
          item_variant: gtm_item_variant,
          upc: gtm_item_upc,
          price: parseFloat(gtm_item_price)
        }]
      };
      if (window.shop_iso_code === 'DE') {
        const item = {
          ...customEvent.items[0],
          category: gtm_item_category,
          item_brand: gtm_item_brand,
          item_sku: gtm_item_sku,
          item_group_id: gtm_item_sku.slice(0, 6),
          item_list_name: gtm_item_list_name,
          item_list_id: gtm_item_list_id
        };
        Object.assign(customEvent, {
          value: gtm_item_price,
          items: [item]
        });
      }
      Shopify.analytics.publish('product_card_selected', customEvent);
    });
  });
}

// only load carousel when .swiper__parent is present
const carouselNodes = document.querySelectorAll('.swiper__parent');
if (carouselNodes.length > 0) {
  import(/* webpackChunkName: "carousel-import" */'./carousel').then(module => module.carouselInit());
}
document.addEventListener('DOMContentLoaded', function () {
  // Select all video elements with the "lazy-video" class
  const lazyVideos = Array.from(document.querySelectorAll('video.lazy-video'));

  // Intersection Observer options
  const observerOptions = {
    root: null,
    rootMargin: '30px',
    threshold: 0.2
  };

  /**
   * Sets the source for all <source> children of a video element and starts playback.
   * @param {HTMLVideoElement} video - The video element to load and play.
   * @param {Boolean} play - Play video for media section.
   */
  const setVideoSrcAndPlayVideo = (video, play) => {
    // Loop through all children of the video element
    Array.from(video.children).forEach(child => {
      if (child.tagName === 'SOURCE') {
        child.src = child.dataset.src;
      }
    });
    video.load();
    if (play) {
      video.play();
    }
  };

  /**
   * Checks for a play button associated with the video and attaches click events.
   * If no button exists, loads and plays the video immediately.
   * @param {HTMLVideoElement} video - The video element to check.
   * @param {Boolean} isAutoplay - Is Autoplay video or not.
   */
  const handlePlayButton = (video, isAutoplay) => {
    const playButton = video.previousElementSibling; // Assume the button is the previous sibling
    if (playButton && playButton.tagName === 'BUTTON') {
      playButton.addEventListener('click', () => {
        setVideoSrcAndPlayVideo(video, true);
      });
    } else {
      // No play button, load and play the video directly
      setVideoSrcAndPlayVideo(video, !isAutoplay);
    }
  };

  /**
   * Applies an Intersection Observer to a lazy-loaded video element.
   * @param {HTMLVideoElement} lazyVideo - The lazy-loaded video element.
   * @param {Boolean} isAutoplay - Is Autoplay video or not.
   */
  const observeLazyVideo = (lazyVideo, isAutoplay) => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // When the video is in the viewport, handle playback
          handlePlayButton(entry.target, isAutoplay);
          entry.target.classList.remove('lazy-video');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    observer.observe(lazyVideo);
  };

  // Iterate through each lazy video and set up the observer or fallback
  lazyVideos.forEach(lazyVideo => {
    const isAutoplay = lazyVideo.getAttribute('autoplay');
    if ('IntersectionObserver' in window) {
      // Use Intersection Observer if supported
      observeLazyVideo(lazyVideo, isAutoplay);
    } else {
      // Fallback: handle video playback immediately
      handlePlayButton(lazyVideo);
    }
  });
});